import * as React from 'react'
import {Util, Time} from 'yougile-util'
import {Lang} from 'yougile-lang'
import {PaymentAction, PaymentStatus, paymentDescr} from 'yougile-model'
import {MoneyVal} from '../common/money-val/money-val'
import {setDisplayName} from '../../../common/utils-ui'

const BillingHistoryItem = (props: PaymentAction) => {
  const bem = Util.bemFrom('billing', 'history', 'item')
  const descr = paymentDescr(props, Lang.getLang())

  return !descr ? null : (
    <div className={bem()}>
      <div className={bem('date')}>
        {Time.formatDate(props.date, {alwaysWithYear: true})}
      </div>
      <div className={bem('descr')}>{descr}</div>
      <div className={bem('amount')}>
        <MoneyVal amount={props.amount} />
      </div>
    </div>
  )
}
setDisplayName(BillingHistoryItem, 'BillingHistoryItem')

export const BillingHistory = (props: PaymentStatus) => {
  const bem = Util.bemFrom('billing', 'history')
  const items = props.history
    .filter(action => action.amount.amount > 0)
    .sort((a, b) => b.date - a.date)
    .map(action => <BillingHistoryItem {...action} key={action.date} />)
    .filter(l => !!l)
  if (items.length === 0) {
    return null
  }
  return (
    <div className={bem()}>
      <div className={bem('title')}>{Lang.msg.billingHistory}:</div>
      <div className={bem('list')}>{items}</div>
    </div>
  )
}
setDisplayName(BillingHistory, 'BillingHistory')
